/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon24Solid = forwardRef('FlagAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4.2 2A2.2 2.2 0 0 0 2 4.2v18.3a1.5 1.5 0 0 0 3 0V17h15.927a1.3 1.3 0 0 0 1.07-2.04l-3.387-4.89a1 1 0 0 1 0-1.14l3.386-4.89A1.3 1.3 0 0 0 20.927 2H4.2Z" })));
});
